import React, { useState } from 'react';
import OperationsList from './OperationsList';
import ConfigPanelBody from '../ConfigPanelBody';
import ConfigPanelFooter from '../ConfigPanelFooter';
import ButtonDefault from '../../../buttons/ButtonDefault';
import ButtonPrimary from '../../../buttons/ButtonPrimary';
import Glyphicon from '../../../generic/Glyphicon';
import { useOperator } from './OperatorProvider';
import FormGroup from '../../../generic/FormGroup';
import NavigationOverrideList from './NavigationOverrideList';
import Toggle from '../../../Toggle';

/**
 * The main operator config screen
 */
const OperatorConfiguration = () => {
    const {
        mapElement,
        saveMapElement,
        cancelMapElement,
        setMapElement,
        setCurrentScreen,
        setSelectedOperationIndex,
        setSelectedNavigationIndex,
        OPERATOR_SCREENS,
    } = useOperator();

    const [hasSubmitted, setHasSubmitted] = useState(false);
    const isValid = mapElement.developerName !== '';

    const onChangeName = ({ target: { value } }) => {
        setMapElement({
            ...mapElement,
            developerName: value,
        });
    };

    const onAddOperation = () => {
        setSelectedOperationIndex(null);
        setCurrentScreen(OPERATOR_SCREENS.operationDetails);
    };

    const onAddMacro = () => {
        setSelectedOperationIndex(null);
        setCurrentScreen(OPERATOR_SCREENS.macroDetails);
    };

    const onAddNavigation = () => {
        setSelectedNavigationIndex(null);
        setCurrentScreen(OPERATOR_SCREENS.navigationDetails);
    };

    const onChangeClearOverrides = ({ isOn }) => {
        setMapElement({
            ...mapElement,
            clearNavigationOverrides: isOn,
        });
    };

    const onChangeComments = ({ target: { value } }) => setMapElement({
        ...mapElement, 
        developerSummary: value 
    });

    const onSave = () => {
        setHasSubmitted(true);
        if (isValid) {
            saveMapElement();
        }
    };

    return (
        <>
            <ConfigPanelBody>
                <h3 className="margin-top-small">
                    <Glyphicon glyph="cog" className="margin-right-sml" />
                    Operator
                </h3>

                <FormGroup
                    label="Name"
                    isRequired
                    isValid={isValid}
                    validationMessage="Please choose a name."
                    showValidation={hasSubmitted}
                >
                    <input
                        data-testid="operator-name"
                        value={mapElement.developerName}
                        onChange={onChangeName}
                        maxLength="255"
                        required
                        className="form-control form-control-width"
                        type="text"
                    />
                </FormGroup>

                <h4>Operations</h4>

                <div className="margin-bottom flex">
                    <ButtonPrimary className="flex-child-right" onClick={onAddOperation}>
                        <Glyphicon glyph="plus" />
                        Add Operation
                    </ButtonPrimary>

                    <ButtonPrimary className="flex-child-right" onClick={onAddMacro}>
                        <Glyphicon glyph="plus" />
                        Add Macro
                    </ButtonPrimary>
                </div>

                <OperationsList />

                <h4>Override Navigation</h4>

                <div className="margin-bottom flex">
                    <ButtonPrimary className="flex-child-right" onClick={onAddNavigation}>
                        <Glyphicon glyph="plus" />
                        Add Navigation Override
                    </ButtonPrimary>
                </div>

                <NavigationOverrideList />

                <FormGroup>
                    <label>
                        <Toggle isOn={mapElement.clearNavigationOverrides} onChange={onChangeClearOverrides} />
                        Clear all navigation overrides
                    </label>
                </FormGroup>   

                <FormGroup
                    label="Comments about this Operator"                    
                >
                    <textarea 
                        data-testid='comments'
                        className="form-control form-textarea" 
                        value={mapElement.developerSummary ?? ''}
                        onChange={onChangeComments}
                    />
                </FormGroup>
           

            </ConfigPanelBody>
            <ConfigPanelFooter>
                <ButtonDefault className="flex-child-right" onClick={cancelMapElement}>
                    Cancel
                </ButtonDefault>
                <ButtonPrimary className="margin-left" onClick={onSave}>
                    Save
                </ButtonPrimary>
            </ConfigPanelFooter>
        </>
    );
};

export default OperatorConfiguration;
